import { useState, createContext, useContext } from "react";

const authContext = createContext({ampouleno:0});
 
export default authContext;